"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _IllegalArgumentException = _interopRequireDefault(require("../../../../java/lang/IllegalArgumentException"));

var _CGAlgorithmsDD = _interopRequireDefault(require("./CGAlgorithmsDD"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Orientation =
/*#__PURE__*/
function () {
  function Orientation() {
    _classCallCheck(this, Orientation);

    Orientation.constructor_.apply(this, arguments);
  }

  _createClass(Orientation, [{
    key: "getClass",
    value: function getClass() {
      return Orientation;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "index",
    value: function index(p1, p2, q) {
      return _CGAlgorithmsDD.default.orientationIndex(p1, p2, q);
    }
  }, {
    key: "isCCW",
    value: function isCCW(ring) {
      var nPts = ring.length - 1;
      if (nPts < 3) throw new _IllegalArgumentException.default("Ring has fewer than 4 points, so orientation cannot be determined");
      var hiPt = ring[0];
      var hiIndex = 0;

      for (var i = 1; i <= nPts; i++) {
        var p = ring[i];

        if (p.y > hiPt.y) {
          hiPt = p;
          hiIndex = i;
        }
      }

      var iPrev = hiIndex;

      do {
        iPrev = iPrev - 1;
        if (iPrev < 0) iPrev = nPts;
      } while (ring[iPrev].equals2D(hiPt) && iPrev !== hiIndex);

      var iNext = hiIndex;

      do {
        iNext = (iNext + 1) % nPts;
      } while (ring[iNext].equals2D(hiPt) && iNext !== hiIndex);

      var prev = ring[iPrev];
      var next = ring[iNext];
      if (prev.equals2D(hiPt) || next.equals2D(hiPt) || prev.equals2D(next)) return false;
      var disc = Orientation.index(prev, hiPt, next);
      var isCCW = null;

      if (disc === 0) {
        isCCW = prev.x > next.x;
      } else {
        isCCW = disc > 0;
      }

      return isCCW;
    }
  }]);

  return Orientation;
}();

exports.default = Orientation;

Orientation.constructor_ = function () {};

Orientation.CLOCKWISE = -1;
Orientation.RIGHT = Orientation.CLOCKWISE;
Orientation.COUNTERCLOCKWISE = 1;
Orientation.LEFT = Orientation.COUNTERCLOCKWISE;
Orientation.COLLINEAR = 0;
Orientation.STRAIGHT = Orientation.COLLINEAR;